import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="editor_align_right-a" d="M8,4 L8,3 L14,3 L14,4 L8,4 Z M4,7 L4,6 L14,6 L14,7 L4,7 Z M8,10 L8,9 L14,9 L14,10 L8,10 Z M4,13 L4,12 L14,12 L14,13 L4,13 Z"/>
    </defs>
    <g>
      <use xlinkHref="#editor_align_right-a"/>
    </g>
  </svg>
);
